import React from 'react';
import MaskedInput from 'react-text-mask';

export default function MaskField({ mask, ...props }) {
  const masks = {
    mac: [
      /\w/,
      /\w/,
      ':',
      /\w/,
      /\w/,
      ':',
      /\w/,
      /\w/,
      ':',
      /\w/,
      /\w/,
      ':',
      /\w/,
      /\w/,
      ':',
      /\w/,
      /\w/,
    ],
    date: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  };

  return (
    <MaskedInput
      {...props}
      guide={false}
      mask={masks[mask] || masks[props.type] || false}
    />
  );
}
